import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content-container p-15 p-sm-20 p-md-25 p-lg-30" };
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-25" };
const _hoisted_3 = { class: "mb-0 fw-bold text-black" };
const _hoisted_4 = { "aria-label": "breadcrumb" };
const _hoisted_5 = { class: "breadcrumb mb-0" };
const _hoisted_6 = { class: "breadcrumb-item" };
const _hoisted_7 = {
    class: "breadcrumb-item active",
    "aria-current": "page"
};
const _hoisted_8 = {
    class: "breadcrumb-item active",
    "aria-current": "page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_GiftCardList = _resolveComponent("GiftCardList");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('sidebar.giftCards')), 1),
            _createElementVNode("nav", _hoisted_4, [
                _createElementVNode("ol", _hoisted_5, [
                    _createElementVNode("li", _hoisted_6, [
                        _createVNode(_component_router_link, {
                            to: "/home",
                            class: "text-decoration-none"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('sidebar.dashboard')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.$t('sidebar.marketing')), 1),
                    _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t('sidebar.giftCards')), 1)
                ])
            ])
        ]),
        _createVNode(_component_GiftCardList)
    ]));
}
